module.exports = __webpack_public_path__ + "static/startupgrindBig-414273af5762aa114a6d681195004300.png";